export class AuditLogItem {

    ID: number;
    LicenseID: number;
    LicenseKey: string;
    MemberID: number;
    MemberName: string;

    IP: string;
    Mac: string;
    ComputerName: string;
    SoftwareVersion: string;

    DateTimeCreated: Date;


    static FixDate(item: AuditLogItem) {
        item.DateTimeCreated = new Date(item.DateTimeCreated);
    }

}

export class AuditLogItemArray extends Array<AuditLogItem>  {

    constructor(...items: AuditLogItem[]) {
        super(...items);
        Object.setPrototypeOf(this, AuditLogItemArray.prototype);
    }

    static FixDates(items: AuditLogItemArray) {
        items.forEach(x => AuditLogItem.FixDate(x));
    }

}
